import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    popoutRoute: (count: number) =>
      translate({ id: 'contextualMenu.stylesOnMap.route.popOut', values: { count } }),
    hideRoute: (count: number) =>
      translate({ id: 'contextualMenu.stylesOnMap.route.hideRoute', values: { count } }),
  }))

  return api
}
